import React from "react";
import { Route } from "react-router-dom";
import FAQS from "../components/index";

const FAQSRoutes = () => {
  return (
    <>
      <Route path="/faqs" element={<FAQS />} /> 
    </>
  );
};

export default FAQSRoutes;
